// extracted by mini-css-extract-plugin
export default {"container":"l3-z","heading":"m3-z","links":"n3-z","copy":"o3-z","subCopy":"p3-z","linksLeft":"q3-z","linksCenter":"r3-z","linksRight":"s3-z","link":"t3-z","onlyLink":"u3-z"};